@if (size !== 'small') {
  @if (badgeValue) {
    <span>{{ badgeValue }}</span>
  } @else {
    @if (text) {
      <span>{{ text }}</span>
    }
  }
}
